export enum EBranchesColumnKeys {
  Name = 'name',
  Guid = 'guid',
}

export enum EBranchesFormKeys {
  Name = 'name',
  CounterpartyGuid = 'counterparty_guid',
}

export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}

export enum EUserManagementBranchesPageGetParams {
  Action = 'action',
}

export enum EUserManagementBranchesPageGetParamsActionTypes {
  Create = 'create',
}
